import axios from 'axios'
const header = {
  'x-api-key': process.env.REACT_APP_X_API_KEY_UTILITIES
}
export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_UTILITIES,
  headers: { ...header }
})